// Calls and Meetings AI: actions. The action points that the call notes give
// to the IM, on the Desk Dashboard (`wealth.ai.calls-meetings.actions`, ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const ActionPointsCard = lazy(() =>
    import('./calls-meetings-actions.slots').then((m) => ({ default: m.ActionPointsCard })),
);

export default defineWebFeature({
    id: 'wealth.ai.calls-meetings.actions',
    slots: {
        'desk.dashboard.cards': [
            {
                key: 'action-points',
                order: 30,
                span: 4,
                rows: 2,
                title: 'Action points from calls',
                summary: 'The open action points that the call notes give to you.',
                href: '/desk/calls-meetings',
                countLabel: (n) => `${n} open`,
                emptyBehaviour: 'collapse',
                count: (ctx) =>
                    ctx.overview
                        ? (ctx.overview.actionPoints ?? []).filter((a) =>
                              ctx.keepClient(a.clientId),
                          ).length
                        : null,
                Component: ActionPointsCard,
            },
        ],
    },
});
